import { inject } from '@angular/core';
import { ResolveFn } from '@angular/router';
import { DirectoryDto } from '../entities/directory-dto';
import { DirectoryApiService } from '../services/directory-api-service';

export const directoryResolver: ResolveFn<DirectoryDto> = () => {
  return inject(DirectoryApiService).getDirectories();
};